import("./config").then(() => {
  import("./app");
});
